import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import * as AWS from 'aws-sdk';
import { environment } from '../../environments/environment';


@Component({
    selector: 'app-monturaselector',
    template: `
        <select class="custom-select mb-3 select-horizons" (change)="onChange($event)">
            <option selected>Choose frame...</option>
            <option *ngFor="let frame of frames">{{ frame }}</option>
        </select>
    `
})
export class MonturaComponent {

    private frames: string[] = [];
    @Output() onSelection = new EventEmitter<string>();
    private creds = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: environment.catalogaccess.identityPoolId
    });

    private client: any;

    public load(catalog: string) {
        this.frames = [];

        AWS.config.update({
            region: environment.catalogaccess.region,
            credentials: this.creds
        });
        // AWS.config.credentials = this.creds;
        this.client = new AWS.S3();
        this.client.listObjects({
            Bucket: environment.catalogaccess.bucketName,
            Delimiter: '/',
            Prefix: catalog + '/'
        }, (err, data) => {

            data.CommonPrefixes.forEach((prefix) => {
                this.frames.push(prefix.Prefix
                    .replace(/^[^\/]*\//, '')
                    .replace(/\/$/, '')
                );
            });
        })
    }

    private onChange(event) {
        let selection = event.target || event.srcElement;
        this.onSelection.emit(selection.options[selection.selectedIndex].value);
    }
    
    public reset() {
        this.frames = [];
        this.onSelection.emit(null);
    }
}